(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('cca-collection-sidebar')) {
    customElements.define('cca-collection-sidebar', class extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      setExpanded(button, expanded) {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel || !this.contains(panel)) return;
        if (!expanded && panel.contains(document.activeElement)) button.focus();
        button.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
      }

      onClick(event) {
        if (!window.matchMedia('(min-width: 769px)').matches) return;
        const button = event.target.closest('[data-cca-sidebar-toggle]');
        if (!button || !this.contains(button)) return;
        this.setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !window.matchMedia('(min-width: 769px)').matches) return;
        const currentButton = event.target.closest('[data-cca-sidebar-toggle]');
        if (currentButton && currentButton.getAttribute('aria-expanded') === 'true') {
          this.setExpanded(currentButton, false);
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        const panel = event.target.closest('[data-cca-sidebar-panel]');
        if (!panel || !this.contains(panel)) return;
        const button = this.querySelector('[aria-controls="' + CSS.escape(panel.id) + '"]');
        if (!button) return;
        this.setExpanded(button, false);
        button.focus();
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
